import '../assets/styles/global.css';
import { Lora, Nunito } from 'next/font/google';
import { appWithTranslation } from 'next-i18next';
import Script from 'next/script';

// If loading a variable font, you don't need to specify the font weight
const nunito = Nunito({ subsets: ['latin'], weight: ["200", "500", "600"] });
const lora = Lora({ subsets: ['latin'], weight: ["600", "700"] });

const App = ({ Component, pageProps }) => (
  <>
    <Component className={`${nunito.className} ${lora.className}`} {...pageProps} />
    <Script src="https://scripts.simpleanalyticscdn.com/latest.js" />
  </>
);

export default appWithTranslation(App);
